"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTotalByQuotation = exports.getDiscountedTotal = exports.appliesDiscountForSummary = exports.appliesDiscountForPayment = exports.appliesAutoPxForPayment = exports.appliesYappyForPayment = exports.appliesAutoPxDiscount = exports.appliesDiscount = exports.getDiscountTotalById = exports.discountOrEmpty = void 0;
var authentication_1 = require("../../authentication");
var constants_1 = require("../../constants");
var paymentQuantityTypes_1 = require("../../constants/paymentQuantityTypes");
var paymentTypes_1 = require("../../constants/paymentTypes");
var products_1 = require("../../constants/products");
var factory_1 = require("../../models/factory");
var quotationMethods_1 = require("./quotationMethods");
/**
 * Checks if a quotation's Total contains a discount array.
 */
function discountOrEmpty(total, discountId, totalFirstDayPayment) {
    var usedDiscount = total.discounts || [];
    var selectedDiscount = usedDiscount.find(function (discount) { return discount.id === discountId; }) ||
        factory_1.makeEmptyDiscount();
    if (totalFirstDayPayment) {
        return __assign(__assign({}, selectedDiscount), { total: totalFirstDayPayment });
    }
    return selectedDiscount;
}
exports.discountOrEmpty = discountOrEmpty;
/** Get discounted total by discount ID */
function getDiscountTotalById(discount, id) {
    var _a;
    return ((_a = discount.find(function (item) { return item.id === id; })) === null || _a === void 0 ? void 0 : _a.total) || 0;
}
exports.getDiscountTotalById = getDiscountTotalById;
/**
 * Returns true if a discount must be applied for the provided quotation
 *
 * @param quotation - The quotation to check for
 */
function appliesDiscount(quotation) {
    var usedDiscount = quotationMethods_1.defaultUnit(quotation).total.discounts || [];
    var hasElectronicDiscount = usedDiscount.find(function (discount) { return discount.id === constants_1.discountTypes.ELECTRONIC_DISCOUNT_ID; });
    return ((quotation.productId === products_1.COMPLETE_VEHICLE ||
        quotation.quotationProfile.id === 31) &&
        typeof hasElectronicDiscount !== 'undefined');
}
exports.appliesDiscount = appliesDiscount;
/**
 * Verifies if the quotation applies AutoPx discount
 * @param quotation
 * @returns boolean
 */
function appliesAutoPxDiscount(quotation) {
    var loggedRol = authentication_1.getLoggedRole();
    var usedDiscount = quotationMethods_1.defaultUnit(quotation).total.discounts || [];
    var hasAutoPxDiscount = usedDiscount.find(function (discount) { return discount.id === constants_1.discountTypes.AUTOPX_DISCOUNT_ID; });
    return (quotation.isAutoPx &&
        typeof hasAutoPxDiscount !== 'undefined' &&
        quotation.productId === products_1.COMPLETE_VEHICLE &&
        (loggedRol === '' || loggedRol === quotation.user.role));
}
exports.appliesAutoPxDiscount = appliesAutoPxDiscount;
/**
 * Verifies if a quotation is applicable for yappy discount.
 *
 * @param quotation The quotation to check.
 * @param paymentType The selected payment method.
 * @returns boolean
 */
function appliesYappyForPayment(quotation, paymentType, paymentQuantityType) {
    var notApplyQuotationID = [31];
    return (appliesDiscount(quotation) &&
        !notApplyQuotationID.includes(quotation.quotationProfile.id) &&
        paymentType === paymentTypes_1.yappyPayment &&
        paymentQuantityType === paymentQuantityTypes_1.ANNUAL);
}
exports.appliesYappyForPayment = appliesYappyForPayment;
/**
 * Verifies if the quotation is elegible for autoPX
 *
 * @param quotation The quotation to check
 * @param paymentType The selected payment method
 * @returns
 */
function appliesAutoPxForPayment(quotation, paymentType) {
    return appliesAutoPxDiscount(quotation) && paymentType === paymentTypes_1.creditCard;
}
exports.appliesAutoPxForPayment = appliesAutoPxForPayment;
/**
 * This method returns true if the quotation allows for discount, and the selected payment also applies
 *
 * @param quotation - The quotation to check
 * @param paymentType - The selected payment method
 */
function appliesDiscountForPayment(quotation, paymentType) {
    if (quotation.quotationProfile.id === 31) {
        return appliesDiscount(quotation) && [paymentTypes_1.creditCard].includes(paymentType);
    }
    return (appliesDiscount(quotation) && [paymentTypes_1.creditCard, paymentTypes_1.achPayment].includes(paymentType));
}
exports.appliesDiscountForPayment = appliesDiscountForPayment;
/**
 * Will return true if the product related to the provided summary actually has a valid insured value
 * to display (in some products, insuredv value does not apply to it is assigned to 0 and should not
 * be displayed).
 *
 * @param quotationSummary - The source summary
 */
function appliesDiscountForSummary(quotationSummary) {
    return quotationSummary.productType === products_1.COMPLETE_VEHICLE;
}
exports.appliesDiscountForSummary = appliesDiscountForSummary;
/**
 * Function that returns total with elegible discounts depending on its payment method.
 * If no discounts are elegible, returns the normal price
 *
 * @param total The current quotation's Total object.
 * @param quotation The quotation to check.
 * @param paymentType The selected payment method.
 */
function getDiscountedTotal(_a) {
    var total = _a.total, quotation = _a.quotation, paymentType = _a.paymentType, _b = _a.paymentQuantityType, paymentQuantityType = _b === void 0 ? '' : _b, totalFirstDayPayment = _a.totalFirstDayPayment;
    // AutoPx Discount
    if (appliesAutoPxForPayment(quotation, paymentType)) {
        var _c = discountOrEmpty(total, constants_1.discountTypes.AUTOPX_DISCOUNT_ID, totalFirstDayPayment), rate = _c.rate, discountedTotal = _c.total;
        return {
            discountType: 'AutoPx',
            rateDiscount: rate,
            grandTotal: discountedTotal,
        };
    }
    // TCR Discount
    // * For now, yappy and TCR discounts are the same, separate them if rates are different in the future.
    if (appliesDiscountForPayment(quotation, paymentType) ||
        appliesYappyForPayment(quotation, paymentType, paymentQuantityType)) {
        var _d = discountOrEmpty(total, constants_1.discountTypes.ELECTRONIC_DISCOUNT_ID, totalFirstDayPayment), rate = _d.rate, discountedTotal = _d.total;
        return {
            discountType: 'Electronic',
            rateDiscount: rate,
            grandTotal: discountedTotal,
        };
    }
    // No discount
    return {
        discountType: 'none',
        rateDiscount: 0,
        grandTotal: totalFirstDayPayment || total.grandTotal,
    };
}
exports.getDiscountedTotal = getDiscountedTotal;
/**
 * Validates if a quotation has a valid discount
 *
 * @param total The current quotation's Total object.
 * @param quotation The quotation to check.
 */
function getTotalByQuotation(total, quotation) {
    // AutoPx Discount
    if (appliesAutoPxDiscount(quotation)) {
        var _a = discountOrEmpty(total, constants_1.discountTypes.AUTOPX_DISCOUNT_ID), rate = _a.rate, discountedTotal = _a.total;
        return {
            discountType: 'AutoPx',
            rateDiscount: rate,
            grandTotal: discountedTotal,
        };
    }
    // Electronic Discount
    if (appliesDiscount(quotation)) {
        var _b = discountOrEmpty(total, constants_1.discountTypes.ELECTRONIC_DISCOUNT_ID), rate = _b.rate, discountedTotal = _b.total;
        return {
            discountType: 'Electronic',
            rateDiscount: rate,
            grandTotal: discountedTotal,
        };
    }
    // No Discount
    return {
        discountType: 'none',
        rateDiscount: 0,
        grandTotal: total.grandTotal,
    };
}
exports.getTotalByQuotation = getTotalByQuotation;
//# sourceMappingURL=discountMethods.js.map